import { TournamentsCardProps } from './props';

import { useTournamentCardVersion } from '@/hooks/tournaments/useTournamentCardVersion';
import { SettingLayoutComponentId } from '@starsoft/common/models';
import dynamic from 'next/dynamic';

const TournamentsCardV1 = dynamic(() => import('./Versions/V1'), {
  ssr: true,
});
const TournamentsCardV2 = dynamic(() => import('./Versions/V2'), {
  ssr: true,
});
const TournamentsCardV3 = dynamic(() => import('./Versions/V3'), {
  ssr: true,
});

function TournamentsCard(props: TournamentsCardProps) {
  const { tournamentCardId } = useTournamentCardVersion();

  switch (tournamentCardId) {
    case SettingLayoutComponentId.TournamentCardV1?.toString():
      return <TournamentsCardV1 {...props} />;
    case SettingLayoutComponentId.TournamentCardV2?.toString():
      return <TournamentsCardV2 {...props} />;
    case SettingLayoutComponentId.TournamentCardV3?.toString():
      return <TournamentsCardV3 {...props} />;
  }
}

export default TournamentsCard;
